import { useEffect, useState } from 'react';

const CHECKLIST = [
  'Business',
  'Branding',
  'Employees',
  'Hours',
  'Appointment Types',
  'Payment Setup',
  'Discounts / Coupons',
];

const OnboardingPopup = ({ onDismiss, onRemindTomorrow, navigate }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const overlay = {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.82)',
    zIndex: 9000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  };

  const modal = {
    background: '#0a1128',
    border: '4px solid #39FF14',
    padding: isMobile ? '24px 18px' : '40px 48px',
    maxWidth: '520px',
    width: '100%',
    boxSizing: 'border-box',
    textAlign: 'center',
    position: 'relative',
    maxHeight: '80vh',
    overflowY: 'auto',
  };

  return (
    <div style={overlay}>
      <div style={modal}>
        <button
          onClick={onDismiss}
          aria-label="Close"
          style={{
            position: 'absolute',
            top: '12px',
            right: '14px',
            background: 'transparent',
            border: 'none',
            color: '#9ca3af',
            fontSize: '22px',
            cursor: 'pointer',
            lineHeight: 1,
            padding: '4px 8px',
          }}
        >
          ✕
        </button>
        <img
          src="/mtnlogo.png"
          alt="MyTool NOW"
          style={{ width: isMobile ? '140px' : '180px', height: 'auto', marginBottom: '20px' }}
        />

        <div style={{
          fontWeight: 900, fontSize: isMobile ? '18px' : '22px',
          color: '#ffffff', textTransform: 'uppercase',
          letterSpacing: '1px', marginBottom: '14px',
        }}>
          Welcome to MyTool NOW!
        </div>

        <div style={{
          fontWeight: 700, fontSize: isMobile ? '13px' : '14px',
          color: '#d1d5db', lineHeight: 1.65, marginBottom: '20px',
        }}>
          You're almost ready to start invoicing, scheduling, and getting paid.
          To unlock everything — including online booking, estimates, and your
          calendar — please complete all modules under Settings before getting started.
        </div>

        <div style={{
          background: '#111827', border: '2px solid #39FF14',
          padding: '14px 20px', marginBottom: '24px', textAlign: 'left',
        }}>
          <div style={{
            fontWeight: 900, fontSize: '11px', color: '#39FF14',
            textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '10px',
          }}>
            Complete these modules in Settings:
          </div>
          {CHECKLIST.map((item) => (
            <div key={item} style={{
              display: 'flex', alignItems: 'center', gap: '10px',
              padding: '5px 0',
              borderBottom: '1px solid #1f2937',
            }}>
              <span style={{ color: '#39FF14', fontSize: '14px', fontWeight: 900 }}>☐</span>
              <span style={{ color: '#ffffff', fontWeight: 700, fontSize: '13px' }}>{item}</span>
            </div>
          ))}
        </div>

        <button
          onClick={() => { onDismiss(); navigate('settings'); }}
          style={{
            display: 'block', width: '100%',
            padding: '16px', marginBottom: '12px',
            background: '#39FF14', color: '#000000',
            fontWeight: 900, fontSize: '16px',
            textTransform: 'uppercase', letterSpacing: '2px',
            border: 'none', cursor: 'pointer',
          }}
        >
          GO TO SETTINGS →
        </button>

        <div style={{ marginBottom: '16px' }}>
          <a
            href="https://www.youtube.com/@MyToolNOW"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: '#2aa8ff', fontWeight: 700,
              fontSize: '13px', textDecoration: 'underline',
            }}
          >
            Need help? Visit our MyTool NOW YouTube Channel
          </a>
        </div>

        <button
          onClick={onRemindTomorrow}
          style={{
            background: 'transparent', border: '2px solid #6b7280',
            color: '#9ca3af', fontWeight: 700, fontSize: '13px',
            padding: '10px 20px', cursor: 'pointer',
            textTransform: 'uppercase', letterSpacing: '1px',
          }}
        >
          Remind me tomorrow
        </button>
      </div>
    </div>
  );
};

export default OnboardingPopup;
